import {
  KeyboardDoubleArrowLeftRounded,
  KeyboardDoubleArrowRightRounded,
} from '@mui/icons-material';
import { Box, IconButton, Tooltip } from '@mui/material';

import { EVENTS, log, logEvent } from '@/services';
import { useReorderOrgPinnedLpsMutation } from '@/store';
import { LearningPath } from '@/types';
import { SnackbarUtils } from '@/utils';

export const ReorderPinnedLpsToolbar = ({
  learningPath,
}: {
  learningPath: LearningPath;
}) => {
  const [reorderOrgPinnedLps, { isLoading: isReorderingOrgPinnedLps }] =
    useReorderOrgPinnedLpsMutation();

  const moveLpToDirection = ({
    lp,
    direction,
  }: {
    lp: LearningPath;
    direction: 'left' | 'right';
  }) => {
    try {
      if (!lp.orderId || isReorderingOrgPinnedLps) return;

      const params = {
        featuredLearningPathId: lp.featuredLearningPathId,
        newOrderId: direction === 'left' ? lp.orderId - 1 : lp.orderId + 1,
      };

      reorderOrgPinnedLps(params);
      logEvent(EVENTS.CONTENT_CURATION_EVENTS.LP_REORDER, params);
    } catch (error) {
      log(
        new Error('Error reordering featured learning paths.', {
          cause: error,
        }),
      );

      SnackbarUtils.error('Error reordering featured learning paths.');
    }
  };

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        gap: 4,
      }}>
      <Tooltip title="Swap with Left">
        <IconButton
          // TODO disbaled state
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();

            moveLpToDirection({
              lp: learningPath,
              direction: 'left',
            });
          }}>
          <KeyboardDoubleArrowLeftRounded />
        </IconButton>
      </Tooltip>
      <Tooltip title="Swap with Right">
        <IconButton
          // TODO disabled state
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();

            moveLpToDirection({
              lp: learningPath,
              direction: 'right',
            });
          }}>
          <KeyboardDoubleArrowRightRounded />
        </IconButton>
      </Tooltip>
    </Box>
  );
};
